import type { ElementType } from 'react';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

import { ROUTES } from './routes.constants';

export interface BrowseFilter {
  label: string;
  icon: ElementType;
  path?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export interface EventStatus {
  label: string;
  value: string;
  onClick: () => void;
}

export const BROWSE_FILTERS: BrowseFilter[] = [
  { label: 'New', icon: AutoAwesomeIcon, path: ROUTES.NEW },
  { label: 'Trending', icon: TrendingUpIcon, path: ROUTES.HOME },
  { label: 'Breaking', icon: LocalFireDepartmentIcon, path: ROUTES.BREAKING },
];

export const EVENT_STATUS: EventStatus[] = [
  { label: 'All', value: 'all', onClick: () => {} },
  { label: 'Active', value: 'active', onClick: () => {} },
  { label: 'Resolved', value: 'resolved', onClick: () => {} },
];
